<template>
  <div class="plat-data-panel-uniform-exam"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="batches">
      <template v-if="batches.length">
        <div class="header">
          <span v-if="showLabel"
                class="custom-label">{{label}}</span>
          <el-select v-model="batchId"
                     size="mini"
                     filterable>
            <el-option v-for="batch in batches"
                       :key="batch.id"
                       :label="batch.name"
                       :value="batch.id"/>
          </el-select>
          <div v-if="$scopedSlots.append"
               class="append">
            <slot name="append"
                  v-bind="panelParams"></slot>
          </div>
        </div>
        <div class="body">
          <div class="body-cont">
            <slot v-bind="panelParams"></slot>
          </div>
        </div>
      </template>
      <template v-else>
        <Hint type="empty">
          <div>统考批次数据为空</div>
        </Hint>
      </template>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>统考批次数据加载失败</div>
        <el-button type="text"
                   @click="loadBatches">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import Hint from '../../../../../elements/Hint'
import Wrapper from '../../../../../../mixins/custom/wrapper'
export default {
  name: 'PlatDataPanelUniformExam',
  mixins: [Wrapper],
  components: {
    Hint
  },
  props: {
    label: {
      type: String,
      default: '统考批次'
    },
    showLabel: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      loading: false,
      batches: null,
      batchId: ''
    }
  },
  computed: {
    panelParams () {
      return {
        batchId: this.batchId
      }
    }
  },
  methods: {
    loadBatches () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/portal/data/exam/uniform/batches',
        method: 'post'
      }).then(response => {
        if (response.data) {
          this.batches = response.data['batches'] || []
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    this.loadBatches()
  },
  watch: {
    batches: function (val) {
      if (val && val.length) {
        let active = val.find(batch => batch.active)
        if (!active) {
          let lastBatchId = this.getWrapper('batchId')
          if (lastBatchId) {
            active = val.find(batch => batch.id === lastBatchId)
          }
        }
        if (active) {
          this.batchId = active.id
        } else {
          this.batchId = val[0].id
        }
      }
    },
    batchId: function (val) {
      this.setWrapper('batchId', val)
    }
  }
}
</script>

<style lang="scss">
  .plat-data-panel-uniform-exam {
    height: 100%;
    display: flex;
    flex-direction: column;
    &.is-border {
      & > .header {
        border-bottom: 1px solid #ebeef5;
      }
    }
    & > .header {
      flex: none;
      height: 46px;
      padding: 0 15px;
      line-height: 46px;
      background-color: #fff;
      display: inline-flex;
      align-items: center;
      .el-select {
        width: 240px;
      }
      .custom-label {
        margin-right: 8px;
        font-size: 13px;
      }
    }
    & > .body {
      flex: auto;
      position: relative;
      & > .body-cont {
        position: absolute;
        inset: 0;
      }
    }
  }
</style>
